const MandelbrotCoords = [
	{
		x: "-0.7463",
		y: "0.1102",
	},
	{
		x: "-0.7453",
		y: "0.1127",
	},
	{
		x: "-0.74529",
		y: "0.113075",
	},
	{
		x: "-0.74529",
		y: "0.1102",
	},
	{
		x: "-0.745428",
		y: "0.113009",
	},
	{
		x: "-0.16",
		y: "1.0405",
	},
	{
		x: "-0.925",
		y: "0.266",
	},
	{
		x: "-1.25066",
		y: "0.02012",
	},
	{
		x: "-0.748",
		y: "0.1",
	},
	{
		x: "-0.235125",
		y: "0.0827215",
	},
	{
		x: "-0.722",
		y: "0.246",
	},
];

const Functions = [
	"f(z) = z^4 - 1",
	"f(z) = z^3 - 1",
	"f(z) = 5cos(3z)",
	"f(z) = ln(z)",
	"f(z) = z^3 - 1, a = 2",
	"f(z) = cosh(z) - 1",
];

const PORT = "8080";

export { PORT, MandelbrotCoords, Functions };
